<template>
    <mdb-row class="label-center">


        <mdb-col col="12" sm="12" md="10" lg="12" xl="6" xxl="6" class="pt-4">
            <mdb-row>
                <mdb-col col="5" sm="2" md="2" lg="3" xl="3" xxl="3" class="px-0 label-center">
                    <label class="mr-0">Reg por página</label>
                </mdb-col>
                <mdb-col col="2" sm="2" md="1" lg="1" xl="1" xxl="1" class="pr-0 pl-0">
                    <div class="form__group">
                        <select v-model="perPage" class="browser-default custom-select" @change="changePerPage">
                            <option v-for="(item, index) in optionsPage" :key="index" :value="item.value">{{ item.text
                            }}
                            </option>
                        </select>
                    </div>
                </mdb-col>
                <mdb-col col="4" sm="4" md="4" lg="4" xl="4" xxl="2" class="pr-0 label-center">
                    <label>{{ currentPage * perPage - perPage + 1 }} - {{ ((currentPage * perPage) >= totalRows) ?
                            totalRows : (currentPage * perPage)
                    }} de {{ totalRows }}</label>
                </mdb-col>
            </mdb-row>
        </mdb-col>
        <mdb-col col="12" sm="12" md="2" lg="12" xl="6" xxl="6" class="pt-1">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" :limit="limit" :size="size"
                align="end" :first-number="firstNumber" :last-number="lastNumber" @change="changePage">
            </b-pagination>
        </mdb-col>

    </mdb-row>
</template>

<script>
import { mdbCol, mdbRow } from 'mdbvue';

const Paginator = {
    name: 'Paginator',
    props: {
        totalRows: {
            type: Number,
        },
        currentPage: {
            type: Number,
        },
        perPage: {
            type: Number,
            default: 10
        },
        stylePaginator: {
            type: String,
            default: 'full'
        },
        firstNumber: {
            type: Boolean,
            default: false
        },
        lastNumber: {
            type: Boolean,
            default: false
        },
        limit: {
            type: Number,
            default: 10
        },
        size: {
            type: String,
            default: 'lg'
        }
    },
    data() {
        return {
            optionsPage: [

                { text: '10', value: '10' },
                { text: '15', value: '15' },
                { text: '25', value: '25' }
            ]
        };
    },
    components: {
        mdbCol, mdbRow
    },
    computed: {

    },
    methods: {
        changePage(val) {
            this.$emit('changePage', val)
        },
        changePerPage(val) {
            this.$emit('changePerPage', this.perPage)
        },

    },
    mounted() {

    },
    watch: {

    }
};

export default Paginator;
export { Paginator as Paginator };
</script>

<style>
span.page-link span.page-link:disabled {
    font-size: 1.6rem;
}

.pagination.pagination-lg .page-item .page-link {
    font-size: 1.6rem;
}

.pagination .page-item.active .page-link {
    font-weight: bold;
    background-color: #47ad7e
}

.pagination .page-item.active .page-link:hover {
    font-weight: bold;
    font-size: 1.6rem;
    background-color: #47ad7e
}

div.same-line {
    display: inline;
    /* the default for div */
    width: 100px;
    height: 100px;
    padding: 5px;
    align-items: center;
    vertical-align: center;
}

.browser-default.custom-select {
    font-size: 1.6rem;
    border-radius: .8rem;
    border: 0.15rem solid #bdbdbd;
    width: auto;
    color: #828282;
    margin: 0px;
}

.label-center {
    display: flex;
    align-items: center;
}

label {
    font-size: 1.6rem;
    font-family: Arial;
    cursor: pointer;
    color: black;
    font-family: Open Sans;
    align-items: center;
    align-content: center;
}

@media (min-width:2560px) {}
</style>